
import React from "react";
import "./About.css";
import { Helmet } from "react-helmet";
import img1 from "./images/2.png";

export default function About() {
  const seo = {
    title:
      "אודות עורך דין רז יוסף | 24 שנות ניסיון בדיני משפחה וירושה",

    description:
      "הכירו את עורך דין רז יוסף, נשוי ואב לשלושה, בעל כ־24 שנות ניסיון בעריכת דין. משרד בוטיק המתמחה בדיני משפחה, גירושין, חלוקת רכוש, צוואות, ירושות, אפוטרופסות וייפוי כוח מתמשך.",

    url:
      "https://razfamilylaw.co.il/About",

    image:
      "https://razfamilylaw.co.il/images/img1.png"
  };


const services = [
  "דיני משפחה וגירושין",
  "חלוקת רכוש ואיזון משאבים",
  "מזונות ילדים ומזונות אישה",
  "אחריות הורית וזמני שהות",
  "הסכמי גירושין וגישור",
  "הסכמי ממון לפני נישואין",
  "הסכמי חיים משותפים",
  "ידועים בציבור ותאים משפחתיים חלופיים",
  "ענייני בית הדין הרבני",
  "מרוץ הסמכויות בין בתי המשפט",
  "גירושין בינלאומיים",
  "נישואין אזרחיים",
  "סרבנות גט ועגינות",
  "צווים דחופים וצווי הגנה",
  "תביעות נזיקין בין בני זוג",
  "צוואות, ירושות ועיזבונות",
  "התנגדות לצוואה",
  "סכסוכי ירושה בין יורשים",
  "אפוטרופסות",
  "ניכור הורי",
  "ייפוי כוח מתמשך"
];


  return (
    <div className="about-page" dir="rtl">

      <Helmet>
        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:url" content={seo.url} />
        <meta property="og:image" content={seo.image} />
        <meta
          property="og:site_name"
          content="רז יוסף – משרד עורכי דין"
        />
        <meta property="og:locale" content="he_IL" />

        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <meta name="twitter:title" content={seo.title} />
        <meta
          name="twitter:description"
          content={seo.description}
        />
        <meta name="twitter:image" content={seo.image} />
      </Helmet>

      <div className="about-hero">
        <div className="about-overlay">

          <h1>
            נעים להכיר – עורך דין רז יוסף
          </h1>

          <p>
            ניסיון משפטי, מקצועיות וליווי אישי לאורך הדרך
          </p>

        </div>
      </div>

      <section className="about-content-section">

        <div className="about-content">

          <div className="about-images">

            <img
              src={img1}
              alt="עורך דין רז יוסף – משרד עורכי דין"
              loading="lazy"
            />

          </div>

          <div className="text1">

            <h2>
              נעים להכיר, אני עורך דין רז יוסף
            </h2>

            <p>
              אני נשוי ואב לשלושה ילדים, מתגורר באזור השרון
              ועוסק בעריכת דין מזה כ־24 שנים ברציפות.
              לאורך שנות פעילותי המקצועית צברתי ניסיון
              משפטי רחב והופעתי במגוון תחומים במשפט הישראלי,
              בבתי המשפט ברחבי הארץ ובכל הערכאות:
              בתי משפט השלום, בתי המשפט המחוזיים ובית המשפט העליון.
            </p>

            <p>
              הניסיון שצברתי לאורך השנים העניק לי היכרות
              מעמיקה עם מערכת המשפט בישראל, עם ההליכים
              המשפטיים השונים ועם האתגרים העומדים בפני
              אנשים הנדרשים להתמודד עם סוגיות משפטיות מורכבות.
            </p>

            <h2>
              תחומי העיסוק שלי
            </h2>

            <p>
              בשנים האחרונות מיקדתי את עיקר עבודתי בתחום
              דיני המשפחה, ובכלל זה בסוגיות הנוגעות לפירוק
              התא המשפחתי על כל ההיבטים המשפטיים והאישיים
              הכרוכים בכך.
            </p>

            <p>
              במסגרת פעילותי אני מעניק ייעוץ וייצוג משפטי
              בהליכי גירושין, חלוקת רכוש ואיזון משאבים,
              מזונות ילדים ומזונות אישה, אחריות הורית
              וזמני שהות, וכן בעריכת הסכמי ממון והסכמי
              גירושין והסכמים משפחתיים לסוגיהם.
            </p>

            <p>
              בנוסף, אני עוסק בתחום הצוואות והירושות,
              לרבות טיפול בענייני עיזבונות, וכן בענייני
              אפוטרופסות וייפוי כוח מתמשך.
            </p>

            <p>
              בכל אחד מהתחומים הללו אני מקפיד לבחון את
              נסיבות המקרה לעומקן, להציג בפני הלקוח את
              האפשרויות המשפטיות הרלוונטיות ולגבש דרך
              פעולה המתאימה לצרכיו ולמצבו האישי.
            </p>

            <h2>
              משרד בוטיק – יחס אישי ומחויבות מקצועית
            </h2>

            <p>
              משרדי הוא משרד בוטיק איכותי ודינמי, הפועל
              מתוך הקפדה על מקצועיות, דיסקרטיות ויסודיות.
              אני מאמין כי טיפול משפטי איכותי מתחיל
              בהקשבה אמיתית, בהבנת האדם שמאחורי התיק
              ובהיכרות מעמיקה עם נסיבותיו הייחודיות.
            </p>

            <p>
              לכן אני מקפיד על טיפול אישי, מקצועי, מסור
              ופרטני בכל לקוח ובכל תיק. מבחינתי, אין
              מדובר רק בטיפול בהליך משפטי, אלא בליווי
              אדם בתקופה שבה הוא זקוק להכוונה, לביטחון
              ולמענה משפטי ברור.
            </p>

            <p>
              המשרד מקפיד על דיסקרטיות, זמינות גבוהה
              ומתן מענה אישי ומקצועי לאורך שלבי הטיפול.
              זמינות המשרד היא 24/7.
            </p>

            <div className="about-services">

              {services.map((service, index) => (
                <div
                  className="about-service-item"
                  key={index}
                >
                  <span>✓</span>
                  {service}
                </div>
              ))}

            </div>

            <p className="about-final-text">
              אני מזמין אתכם ליצור קשר עם משרדי לתיאום
              פגישת ייעוץ ולקבלת ליווי משפטי אישי ומקצועי.
              אשמח לעמוד לרשותכם.
              <br />
              עורך דין רז יוסף
            </p>

          </div>

        </div>

      </section>

    </div>
  );
}
